import { createSelector } from 'reselect';
import { AppState } from 'src/store/state';
import { ListingViewPageState } from './state';
import { plainToClass, plainToClassFromExist } from 'class-transformer';
import { Listing } from '../../../entities/listing';
import { DTOGroup } from '../../../enums/dto-group';
import { ServerError } from 'src/entities/server-errors';

const selectFeature = (state: AppState): ListingViewPageState => state.pages.listingView;

export class ListingViewPageSelectors {
  public static isLoading = createSelector(
    selectFeature,
    (state) => state.isLoading
  );

  public static listing = createSelector(
    selectFeature,
    (state) => plainToClass(
      Listing,
      state.listing,
      { groups: [DTOGroup.MAIN], strategy: 'excludeAll' }
    )
  );

  public static error = createSelector(
    selectFeature,
    (state) => plainToClassFromExist(
      new ServerError<Listing>(Listing),
      state.error,
      {
        groups: [DTOGroup.MAIN],
        strategy: 'excludeAll'
      }
    ) as ServerError<Listing>
  );
}
